import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const BACKEND = BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// GST OS client — uses the same cookie/Bearer session as the main app (no localStorage token).
// The old passcode gate was removed, so no X-GST-Token is stored client-side anymore.
export const gstApi = axios.create({ baseURL: API, withCredentials: true });

export const MODELS_FALLBACK = [];
